import { sharedI18nKeys } from '@vlaio/shared/i18n';
import { RedirectI18nKeys } from '@vlaio/shared/redirects';

export const I18nKeys = {
	...sharedI18nKeys,
	...RedirectI18nKeys
};
